import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";

export const ChecklistItemResolvedByParty = union([
    literal("client"),
    literal("conveyancer"),
    literal("third_party"),

    literal("us"),
    literal("seller"),
    literal("buyer"),
    literal("supplier"),
    literal("portal"),
]);
export type TChecklistItemResolvedByPartyCodec = typeof ChecklistItemResolvedByParty;
export type TChecklistItemResolvedByParty = TTypeOfCodec<TChecklistItemResolvedByPartyCodec>;
